import './App.css';
import * as echarts from 'echarts';
import { ConfigProvider,theme } from 'antd';
import {RouterProvider, createBrowserRouter} from 'react-router-dom'
import Base from './Paginas/Base';
import Login from './Paginas/Login';
import Inicio from './Paginas/Inicio';
import ValidarSesion from './Componentes/ValidarSesion';
import AtletaListado from './Paginas/Atletas/Listado';
import CmjGuardar from './Paginas/Prueba/CMJ/Guardar';
import CopGuardar from './Paginas/Prueba/COP/Guardar';
import NordicGuardar from './Paginas/Prueba/Nordic/Guardar';
import DynamoGuardar from './Paginas/Prueba/Dynamo/Guardar';
import AtletaGuardar from './Paginas/Atletas/Guardar';
import InstitucionListado from './Paginas/Institucion/Listado';
import InstitucionGuardar from './Paginas/Institucion/Guardar';
import PruebaListado from './Paginas/Prueba/Listado';
import PruebaDetalle from './Paginas/Prueba/Detalle';
import COP from './Paginas/Prueba/COP/Guardar';
import MuestraDetalle from './Paginas/Prueba/Muestras';
import RequiereBle from './Componentes/Ble/RequiereBle';
import AtletaTendencia from './Paginas/Atletas/Tendencia';
import {transform} from 'echarts-stat';
import PruebaCuadranteDetalle from './Paginas/Prueba/Cuadrante';
import PruebaRankingDetalle from './Paginas/Prueba/Ranking';
import UsuarioListado from './Paginas/Usuario/Listado';
import UsuarioGuardar from './Paginas/Usuario/Guardar';
import ReporteGuardar from './Paginas/Reportes';



echarts.registerTransform(transform.regression);
echarts.registerTheme('dark2', {
  backgroundColor: '#000000',
  contrastColor: 'white'
});


function App() {

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Base />,
      children:[{
        path:'/login',
        element:<Login/>
      },
    {
      path:'/',
      element:<ValidarSesion><Inicio/></ValidarSesion>
    },
    {
      path:'/atletas',
      element:<ValidarSesion><AtletaListado/></ValidarSesion>
    },
    {
      path:'/atleta/guardar',
      element:<ValidarSesion><AtletaGuardar/></ValidarSesion>
    },
    {
      path:'/atleta/:id/actualizar',
      element:<ValidarSesion><AtletaGuardar/></ValidarSesion>
    },
    // {
    //   path:'/atleta/:id/borrar',
    //   element:<ValidarSesion><AtletaBorrar/></ValidarSesion>
    // },
    {
      path:'/atleta/:id/iniciar-prueba/cmj',
      element:<ValidarSesion><RequiereBle><CmjGuardar/></RequiereBle></ValidarSesion>
    },
    {
      path:'/atleta/:id/iniciar-prueba/cop',
      element:<ValidarSesion><RequiereBle><CopGuardar/></RequiereBle></ValidarSesion>
    },
    {
      path:'/atleta/:id/iniciar-prueba/nordic',
      element:<ValidarSesion><RequiereBle><NordicGuardar/></RequiereBle></ValidarSesion>
    },
    {
      path:'/atleta/:id/iniciar-prueba/dynamo',
      element:<ValidarSesion><RequiereBle><DynamoGuardar/></RequiereBle></ValidarSesion>
    },
    {
      path:'/atleta/:id/tendencias',
      element:<ValidarSesion><AtletaTendencia/></ValidarSesion>
    },
    {
      path:'/instituciones',
      element:<ValidarSesion><InstitucionListado/></ValidarSesion>
    },
    {
      path:'/institucion/guardar',
      element:<ValidarSesion><InstitucionGuardar/></ValidarSesion>
    },
    {
      path:'/institucion/:id/actualizar',
      element:<ValidarSesion><InstitucionGuardar/></ValidarSesion>
    },
    {
      path:'/pruebas',
      element:<ValidarSesion><PruebaListado/></ValidarSesion>
    },{
      path:'/prueba/:id',
      element:<ValidarSesion><PruebaDetalle/></ValidarSesion>
    },
    {
      path:'/COP/:id',
      element:<ValidarSesion><COP/></ValidarSesion>
    },
    {
      path:'/prueba/cuadrante/:id',
      element:<ValidarSesion><PruebaCuadranteDetalle/></ValidarSesion>
    },
    {
      path:'/prueba/ranking/:id',
      element:<ValidarSesion><PruebaRankingDetalle/></ValidarSesion>
    },
    {
      path:'/muestra/:id',
      element:<ValidarSesion><MuestraDetalle/></ValidarSesion>
    },
    {
      path:'/usuarios',
      element:<ValidarSesion><UsuarioListado/></ValidarSesion>
    },
    {
      path:'/usuario/:id',
      element:<ValidarSesion><UsuarioGuardar/></ValidarSesion>
    },
    {
      path:'/usuario',
      element:<ValidarSesion><UsuarioGuardar/></ValidarSesion>
    },
    {
      path:'/reportes',
      element:<ValidarSesion><ReporteGuardar/></ValidarSesion>
    },
    
  ]
    },

  ])

  return (
    <ConfigProvider theme={{ 
      algorithm: theme.darkAlgorithm,
      token:{
        colorPrimary:'#faad14'
      },
      components:{
        Segmented:{
          colorText:'#faad14'
        }
      }
     }}>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
